export enum NotificationDiscussionSource {
  QUESTIONNAIRE = "QUESTIONNAIRE",
  REQUIREMENT = "REQUIREMENT",
  SCORECARD = "SCORECARD",
  QUESTIONNAIRE_CROSS_TEAM = "QUESTIONNAIRE_CROSS_TEAM",
}

export enum InitUserTeam {
  EVALUATOR = "EVALUATOR",
  SURVEY_RECIPIENT = "SURVEY_RECIPIENT",
}

export enum UserNotificationType {
  DISCUSSION_ACTIVITY = "DISCUSSION_ACTIVITY",
  DISCUSSION_COMMENT_MENTION = "DISCUSSION_COMMENT_MENTION",
}

export enum WebSocketMessageEvent {
  CONNECT = "CONNECT",
  UNREAD_NOTIFICATION_COUNT = "UNREAD_NOTIFICATION_COUNT",
  VIEWING_INITIATIVE = "VIEWING_INITIATIVE",
  INIT_NAME_UPDATED = "INIT_NAME_UPDATED",
  UPDATE_INITIATIVE_STATE = "UPDATE_INITIATIVE_STATE",
  INITIATIVE_ACCESS_REVOKED = "INITIATIVE_ACCESS_REVOKED",
  INITIATIVE_DELETED = "INITIATIVE_DELETED",
}

export enum ClientEvent {
  NOTIFICATIONS_FEED_VIEWED = "NOTIFICATIONS_FEED_VIEWED",
  NOTIFICATIONS_FEED_MARK_ALL_AS_READ_CLICKED = "NOTIFICATIONS_FEED_MARK_ALL_AS_READ_CLICKED",
  NOTIFICATIONS_FEED_NOTIFICATION_CLICKED = "NOTIFICATIONS_FEED_NOTIFICATION_CLICKED",
}

export enum CustomEvents {
  OVERVIEW_EDIT_COUNT = "OVERVIEW_EDIT_COUNT",
  SELECTION_EDIT_COUNT = "SELECTION_EDIT_COUNT",
  REQUIREMENTS_EDIT_COUNT = "REQUIREMENTS_EDIT_COUNT",
  CHECKLIST_EDIT_COUNT = "CHECKLIST_EDIT_COUNT",
  ROUND_TITLE_UPDATED = "ROUND_TITLE_UPDATED",
  DETAILS_EDIT_COUNT = "DETAILS_EDIT_COUNT",
}
